import type { ComponentProps, ReactNode } from 'react';
import { FieldInfo, useFieldContext } from './shared';
import { Combobox } from '../../custom/combobox';

export default function ComboboxTextField(
	props: ComponentProps<'select'> & {
		label: string;
		search: string;
		empty: string;
		options: { value: string; label: string }[];
		creatable?: boolean;
		children?: ReactNode;
	},
) {
	const field = useFieldContext<string>();

	return (
		<div className={props.className}>
			<div className="text-muted-foreground relative">
				<Combobox
					placeholder={props.label}
					commandEmpty={props.empty}
					searchPlaceholder={props.search}
					creatable={props.creatable}
					options={props.options}
					value={field.state.value}
					onChange={field.handleChange}
					children={props.children}
				/>
			</div>
			<FieldInfo fieldState={field.state} />
		</div>
	);
}
